var acp = window.acp || {};
acp.config = acp.config || {};

export default acp;
